import React, { useMemo } from 'react';
import { FieldSet, Section } from '@alfa-retail-react/components';

export const IntroRkkProductAdvantages = ({
    minAmount,
}: {
    minAmount: number;
}) => {
    const advantages = useMemo(
        () => [
            {
                value: 'Совершайте выгодные покупки онлайн и офлайн - в любых магазинах мира, где принимают карты.',
                className: 'advantagesListItem',
            },
            {
                value: 'Покупайте на акциях - рассрочка действует на все товары без исключения.',
                className: 'advantagesListItem',
            },
            {
                value: 'Закрывайте другие кредиты и улучшайте свою кредитную историю.',
                className: 'advantagesListItem',
            },
            {
                value: 'Погашайте любым способом: через приложение INSNC, ЕРИП, сайт, банкоматы и отделения Альфы - как текущий платеж, так и досрочно.',
                className: 'advantagesListItem',
            },
        ],
        [minAmount],
    );

    return (
        <Section
            className="IntroProductAdvantages"
            title="Как это работает и как погасить"
        >
            <FieldSet
                className="advantagesList possibilities"
                fieldsProps={advantages}
            />
        </Section>
    );
};
